import { buildLSWHPrompt, buildSubjectPrompt, buildVariableSubjectPrompt } from "./aiPrompts";

const LSWH_CHAR_LIMIT = 2000;
const LANGUAGE_CHAR_LIMIT = 1000;
const NATIVE_LANGUAGE_CHAR_LIMIT = 1000;
const FRENCH_CHAR_LIMIT = 1000;
const MATHEMATICS_CHAR_LIMIT = 1000;
const SCIENCE_CHAR_LIMIT = 1000;
const SOCIAL_STUDIES_CHAR_LIMIT = 1000;
const HPPE_CHAR_LIMIT = 1000;
const ARTS_CHAR_LIMIT = 1000;
const OPTIONAL_STUDIES_CHAR_LIMIT = 1000;

export const LSWH_CONFIG = {
  systemPrompt: buildLSWHPrompt(LSWH_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    responsibility1: v.responsibility1,
    organization1: v.organization1,
    independentWork1: v.independentWork1,
    collaboration1: v.collaboration1,
    initiative1: v.initiative1,
    selfRegulation1: v.selfRegulation1,
    responsibility2: v.responsibility2,
    organization2: v.organization2,
    independentWork2: v.independentWork2,
    collaboration2: v.collaboration2,
    initiative2: v.initiative2,
    selfRegulation2: v.selfRegulation2,
  }),
};

export const LANGUAGE_CONFIG = {
  systemPrompt: buildSubjectPrompt("Language", LANGUAGE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    languagePlan: v.languagePlan,
    languageGrade1: v.languageGrade1,
    languageGrade2: v.languageGrade2,
  }),
};

export const NATIVE_LANGUAGE_CONFIG = {
  systemPrompt: buildVariableSubjectPrompt("nativeLanguage", NATIVE_LANGUAGE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    nativeLanguage: v.nativeLanguage,
    nativeLanguagePlan: v.nativeLanguagePlan,
    nativeLanguageGrade1: v.nativeLanguageGrade1,
    nativeLanguageGrade2: v.nativeLanguageGrade2,
  }),
};

export const FRENCH_CONFIG = {
  systemPrompt: buildSubjectPrompt("French", FRENCH_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    frenchPlan: v.frenchPlan,
    frenchListeningGrade1: v.frenchListeningGrade1,
    frenchListeningGrade2: v.frenchListeningGrade2,
    frenchSpeakingGrade1: v.frenchSpeakingGrade1,
    frenchSpeakingGrade2: v.frenchSpeakingGrade2,
    frenchReadingGrade1: v.frenchReadingGrade1,
    frenchReadingGrade2: v.frenchReadingGrade2,
    frenchWritingGrade1: v.frenchWritingGrade1,
    frenchWritingGrade2: v.frenchWritingGrade2,
  }),
};

export const MATHEMATICS_CONFIG = {
  systemPrompt: buildSubjectPrompt("Mathematics", MATHEMATICS_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    mathematicsPlan: v.mathematicsPlan,
    mathematicsGrade1: v.mathematicsGrade1,
    mathematicsGrade2: v.mathematicsGrade2,
  }),
};

export const SCIENCE_CONFIG = {
  systemPrompt: buildSubjectPrompt("Science & Technology", SCIENCE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    scienceAndTechnologyPlan: v.scienceAndTechnologyPlan,
    scienceAndTechnologyGrade1: v.scienceAndTechnologyGrade1,
    scienceAndTechnologyGrade2: v.scienceAndTechnologyGrade2,
  }),
};

export const SOCIAL_STUDIES_CONFIG = {
  systemPrompt: buildSubjectPrompt("Social Studies", SOCIAL_STUDIES_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    socialStudiesPlan: v.socialStudiesPlan,
    socialStudiesGrade1: v.socialStudiesGrade1,
    socialStudiesGrade2: v.socialStudiesGrade2,
  }),
};

export const HPPE_CONFIG = {
  systemPrompt: buildSubjectPrompt("Health & Physical Education", HPPE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    healthEducationPlan: v.healthEducationPlan,
    healthEducationGrade1: v.healthEducationGrade1,
    healthEducationGrade2: v.healthEducationGrade2,
    physicalEducationPlan: v.physicalEducationPlan,
    physicalEducationGrade1: v.physicalEducationGrade1,
    physicalEducationGrade2: v.physicalEducationGrade2,
  }),
};

export const ARTS_CONFIG = {
  systemPrompt: buildSubjectPrompt("The Arts", ARTS_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    artsHeader: v.artsHeader,
    arts1: v.arts1,
    arts1Grade1: v.arts1Grade1,
    arts1Grade2: v.arts1Grade2,
    arts2: v.arts2,
    arts2Grade1: v.arts2Grade1,
    arts2Grade2: v.arts2Grade2,
    arts3: v.arts3,
    arts3Grade1: v.arts3Grade1,
    arts3Grade2: v.arts3Grade2,
    arts4: v.arts4,
    arts4Grade1: v.arts4Grade1,
    arts4Grade2: v.arts4Grade2,
  }),
};

export const OPTIONAL_STUDIES_CONFIG = {
  systemPrompt: buildVariableSubjectPrompt("optionalStudies", OPTIONAL_STUDIES_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    optionalStudies: v.optionalStudies,
    optionalStudiesPlan: v.optionalStudiesPlan,
    optionalStudiesGrade1: v.optionalStudiesGrade1,
    optionalStudiesGrade2: v.optionalStudiesGrade2,
  }),
};
